import React from "react";
import ReactDOM from "react-dom";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import logoutImg from "../images/logged-out-img.png";

function LogoutModal(props) {
  let navigate = useNavigate();
  const { signout } = useAuth();
  const logOut = () => {
    signout(() => {
      navigate("/");
    });
  };
  return ReactDOM.createPortal(
    <React.Fragment>
      <div
        className={"modal fade " + (props.modal ? "show " : "")}
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={props.modal ? { display: "block" } : { display: "none" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header px-4 border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => props.setModal(false)}
              ></button>
            </div>
            <div className="modal-body py-0 pb-4">
              <div className="row justify-content-center text-center">
                <div className="col-sm-8">
                  <img src={logoutImg} className="img-fluid" />
                  <h5 className="fs-20 fw-semibold mt-4" id="exampleModalLabel">
                    Log Out
                  </h5>
                  <p className="fs-16 mb-4">
                    Are you sure you want to Log Out?
                  </p>
                  <div className="row justify-content-center">
                    <div className="col-sm-7">
                      <a
                        onClick={logOut}
                        role="button"
                        className="btn btn-sm btn-danger d-flex align-items-center px-2 fw-medium rounded-3 justify-content-center"
                      >
                        Log Out
                      </a>
                      <a
                        onClick={() => props.setModal(false)}
                        role="button"
                        className="btn btn-sm d-flex align-items-center px-2 fw-medium rounded-3 justify-content-center"
                      >
                        No
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {props.modal ? <div className="modal-backdrop fade show" /> : ""}
    </React.Fragment>,
    document.getElementById("modal-root")
  );
}
export default LogoutModal;
